function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useIsInverseVariant as l } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: t , size: r = 24  } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = l(), s = t !== null && t !== void 0 ? t : n ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ e("path", {
            fill: s,
            d: "M21.841 12.001c0-6.706-3.627-9.846-9.846-9.846-6.218 0-9.84 3.14-9.84 9.846 0 6.706 3.622 9.84 9.84 9.84 6.219 0 9.846-3.134 9.846-9.84zm-9.846 8.61c-5.793 0-8.61-2.817-8.61-8.61 0-5.798 2.817-8.616 8.61-8.616 5.798 0 8.616 2.818 8.616 8.616 0 5.793-2.82 8.61-8.616 8.61zm3.826-13.56a.571.571 0 00-.8.104l-6.945 8.927a.575.575 0 10.908.706l6.941-8.93a.572.572 0 00-.1-.804l-.004-.003zm-6.145 3.891c-1.048 0-1.656-.53-1.656-1.655 0-1.13.611-1.659 1.656-1.659s1.658.53 1.658 1.659c0 1.128-.613 1.655-1.658 1.655zm-.507-1.655c0 .453.05.507.507.507.456 0 .507-.05.507-.507 0-.451-.056-.507-.507-.507-.457 0-.507.05-.507.507zm5.151 3.89c1.045 0 1.658.53 1.658 1.659 0 1.128-.61 1.655-1.658 1.655-1.045 0-1.655-.527-1.655-1.655 0-1.132.607-1.659 1.655-1.659zm0 2.163c.457 0 .51-.053.51-.507 0-.451-.056-.507-.51-.507-.457 0-.507.05-.507.507 0 .454.05.507.507.507z"
        })
    }));
}, h = a;
export { h as default };
